module.exports = __webpack_public_path__ + "img/12.0de9e5d7.jpg";